import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Pattern extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getOlguList(params) {
    return this.httpService.get("Definition/list-template-with-Group", {
      headers,
      params,
    });
  }

  getGroupProfileWithType(params) {
    return this.httpService.get("Definition/combo-group-profile-with-type", {
      headers,
      params,
    });
  }
  getAllGroupProfile(params) {
    return this.httpService.get("/Definition/combo-group-profile", {
      headers,
      params,
    });
  }
  postInsertOlgu(data) {
    return this.httpService.post("Definition/insert-template", data, {
      headers,
    });
  }

  getGlass(params) {
    return this.httpService.get("Definition/combo-product-glass", {
      headers,
      params,
    });
  }

  getShisheGroup(params) {
    return this.httpService.get("Definition/combo-group-product-glass", {
      headers,
      params,
    });
  }

  getTori(params) {
    return this.httpService.get("Definition/combo-net", { headers, params });
  }

  getGroupProfile(params) {
    return this.httpService.get(
      "Definition/combo-group-profile-with-struct-type",
      { headers, params }
    );
  }

  getFrame(params) {
    return this.httpService.get("Definition/combo-frame-profile", {
      headers,
      params,
    });
  }
  getTypeColor(params) {
    return this.httpService.get("Definition/combo-type-color", {
      headers,
      params,
    });
  }
  getColor(params) {
    return this.httpService.get("Definition/combo-color", { headers, params });
  }

  getBrandYaragh(params) {
    return this.httpService.get("Definition/combo-brand-fitting-struct", {
      headers,
      params,
    });
  }
  getAllOlgu(params) {
    return this.httpService.get("Definition/all-country-profile-sid", {
      headers,
      params,
    });
  }

  deleteOlgu(data) {
    return this.httpService.delete("Definition/delete-template", {
      headers,
      data,
    });
  }
  getRelationOlgu(params) {
    return this.httpService.get("Definition/relation-template", {
      headers,
      params,
    });
  }

  getOlguForEdit(params) {
    return this.httpService.get("Definition/select-template-for-update", {
      headers,
      params,
    });
  }

  getIdGroupGlass(params) {
    return this.httpService.get("Definition/select-group-glass-olgu", {
      headers,
      params,
    });
  }
  updateTemplateLolaee(data) {
    return this.httpService.put("Definition/update-template", data, {
      headers,
    });
  }
  updateTemplateRaili(data) {
    return this.httpService.put("Definition/update-template", data, {
      headers,
    });
  }
  disableOlgu(data) {
    return this.httpService.put("Definition/disable-template", data, {
      headers,
    });
  }
}

const PatternService = new Pattern();
export default PatternService;
